import { useMedia } from '../../hooks/useMedia';

export const coreWidthBreakpoints = {
  extraSlim: 320,
  slim: 360,
  narrow: 375,
  medium: 620,
  wide: 1024,
  mediumWide: 1366,
  extraWide: 1512,
  extraExtraWide: 1800,
};

export const coreHeightBreakpoints = {
  /*extraShort: x,*/
  short: 320,
  medium: 500,
  /*tall: x,*/
  /*extraTall: x,*/
};

/* Larger Than: "mobile-first" */

export const useIsLargerThanExtraExtraWide = (): boolean => {
  //(width >= 1800px)
  return useMedia(
    `(min-width: ${coreWidthBreakpoints.extraExtraWide}px) and (min-height: ${coreHeightBreakpoints.medium}px)`
  );
};

export const useIsLargerThanExtraWide = (): boolean => {
  //(width >= 1512px)
  return useMedia(
    `(min-width: ${coreWidthBreakpoints.extraWide}px) and (min-height: ${coreHeightBreakpoints.medium}px)`
  );
};

export const useIsLargerThanMediumWide = (): boolean => {
  //(width >= 1366px)
  return useMedia(
    `(min-width: ${coreWidthBreakpoints.mediumWide}px) and (min-height: ${coreHeightBreakpoints.medium}px)`
  );
};

export const useIsLargerThanWide = (): boolean => {
  //(width >= 1024px), (height >= 500px)
  return useMedia(`(min-width: ${coreWidthBreakpoints.wide}px) and (min-height: ${coreHeightBreakpoints.medium}px)`);
};

export const useIsLargerThanMedium = (): boolean => {
  //(width >= 620px)
  return useMedia(`(min-width: ${coreWidthBreakpoints.medium}px)`);
};

export const useIsLargerThanNarrow = (): boolean => {
  //(width >= 375px)
  return useMedia(`(min-width: ${coreWidthBreakpoints.narrow}px)`);
};

/* Smaller Than: "desktop-first" */

export const useIsSmallerThanExtraExtraWide = (): boolean => {
  //(width < 1800px)
  return useMedia(
    `(max-width: ${coreWidthBreakpoints.extraExtraWide - 1}px), (max-height: ${coreHeightBreakpoints.medium - 1}px)`
  );
};

export const useIsSmallerThanExtraWide = (): boolean => {
  //(width < 1512px)
  return useMedia(
    `(max-width: ${coreWidthBreakpoints.extraWide - 1}px), (max-height: ${coreHeightBreakpoints.medium - 1}px)`
  );
};

export const useIsSmallerThanMediumWide = (): boolean => {
  //(width < 1366px)
  return useMedia(
    `(max-width: ${coreWidthBreakpoints.mediumWide - 1}px), (max-height: ${coreHeightBreakpoints.medium - 1}px)`
  );
};

export const useIsSmallerThanWide = (): boolean => {
  //(width < 1024px), (height < 500px)
  return useMedia(
    `(max-width: ${coreWidthBreakpoints.wide - 1}px), (max-height: ${coreHeightBreakpoints.medium - 1}px)`
  );
};

export const useIsSmallerThanMedium = (): boolean => {
  //(width < 620px)
  return useMedia(`(max-width: ${coreWidthBreakpoints.medium - 1}px)`);
};

export const useIsSmallerThanNarrow = (): boolean => {
  //(width < 375px)
  return useMedia(`(max-width: ${coreWidthBreakpoints.narrow - 1}px)`);
};

export const useIsCompressed = (): boolean => {
  //(height < 320px), (width < 360px)
  return useMedia(
    `(max-height: ${coreHeightBreakpoints.short - 1}px), (max-width: ${coreWidthBreakpoints.slim - 1}px)`
  );
};

export const useIsUncompessed = (): boolean => {
  //(height >= 320px) and (width >= 360px)
  return useMedia(`(min-height: ${coreHeightBreakpoints.short}px) and (min-width: ${coreWidthBreakpoints.slim}px)`);
};

export const useIsLandscape = (): boolean => {
  return useMedia('(orientation: landscape)');
};

export const useIsPortrait = (): boolean => {
  return useMedia('(orientation: portrait)');
};
